import script from "./ActionVideoGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionVideoGallery.vue?vue&type=script&setup=true&lang=js"

import "./ActionVideoGallery.vue?vue&type=style&index=0&id=5d2bc7be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2bc7be"]])

export default __exports__